import { useRouter } from "next/router";
import { useRegion } from "core/hooks/useRegion";
import { getBrandCode } from "core/utils/getBrandCode";
import { BrandCode, RegionCode } from "core/entities";
import { EventArticleFilterFormValues } from "../entities";
import { timeFiltersToStartEndDates } from "../utils/timeFiltersToStartEndDates";

export function useInitialEventsArticlesFilters(): EventArticleFilterFormValues {
  const {
    query: { tags: queryTags, categories: queryCategories, types: queryTypes },
  } = useRouter();
  const brand = getBrandCode();
  const region = useRegion();
  const brands: BrandCode[] = brand ? [brand] : [];
  const regions: RegionCode[] = region ? [region] : [];

  const categories: string[] =
    typeof queryCategories === "string" ? [queryCategories] : [];

  const tags: string[] = typeof queryTags === "string" ? [queryTags] : [];
  const types: string[] = typeof queryTypes === "string" ? [queryTypes] : [];
  const startEndFilters = timeFiltersToStartEndDates(["current", "future"]);

  const eventsFormValues: EventArticleFilterFormValues = {
    brands,
    regions,
    categories,
    tags,
    types,
    ...startEndFilters,
  };
  return eventsFormValues;
}
